/* erzeugt aus preview/ (shop-port.js) */
/* OTHERSPORTS · Trainingssystem-Finder
   Zustandsmaschine nach „Produktfinder – Spezifikation V1“. Fragen, Routing, Setlogik und
   Textbausteine liegen mit ihren stabilen IDs in assets/data/finder.json – hier steht nur
   die Ablauf- und Darstellungslogik. */
(function () {
  'use strict';

  var DATA_URL = window.OS_NEU_ASSET('finder.json');
  var doc = document;
  var overlay = doc.getElementById('os-finder');
  if (!overlay) return;

  var dialog = overlay.querySelector('.os-finder__dialog');
  var stage = overlay.querySelector('[data-finder-stage]');
  var progress = overlay.querySelector('[data-finder-progress]');
  var countEl = overlay.querySelector('[data-finder-count]');
  var barEl = overlay.querySelector('[data-finder-bar]');
  var backBtn = overlay.querySelector('[data-finder-back]');

  var data = null;
  var loading = null;
  var opener = null;
  var state = freshState();

  function freshState() {
    // answers: Question_ID → Answer_ID · history: bereits beantwortete Fragen in Reihenfolge
    return { current: null, history: [], answers: {}, route: null, vorauswahl: false };
  }

  function track(event, payload) {
    if (window.osTrack) window.osTrack(event, payload);
  }

  /* Daten ------------------------------------------------------------------- */
  function load() {
    if (data) return Promise.resolve(data);
    if (!loading) {
      loading = fetch(DATA_URL)
        .then(function (res) { if (!res.ok) throw new Error(res.status); return res.json(); })
        .then(function (json) { data = json; return json; })
        .catch(function (err) { loading = null; throw err; });
    }
    return loading;
  }

  /* Eine Frage liefert ihre Antworten direkt oder über eine Antwortgruppe (Q2_*). */
  function answersOf(qid) {
    var q = data.fragen[qid];
    if (q.antworten) return q.antworten;
    return data.antwortgruppen[q.antwortgruppe].map(function (a) {
      return { id: q.idPraefix + a.suffix, text: a.text, feld: a.feld, wert: a.wert, weiter: q.weiter };
    });
  }
  function findAnswer(qid, aid) {
    return answersOf(qid).filter(function (a) { return a.id === aid; })[0] || null;
  }

  /* Abgeleitetes Datenmodell (Tab „Ergebnisaufbau“): wird immer aus den Antworten entlang
     des aktuellen Pfads neu berechnet – nie zwischengespeichert. */
  function derive() {
    var model = { product_id: null, goal_context_id: null };
    state.history.forEach(function (qid) {
      var a = findAnswer(qid, state.answers[qid]);
      if (!a) return;
      model[a.feld] = a.wert;
      if (a.produkt) { model.product_id = a.produkt; model.goal_context_id = a.goalContext; }
    });
    if (model.product_id && model.equipment_id) {
      var set = data.setlogik[model.product_id][model.equipment_id];
      model.setup_id = set.id;
      model.kickoff_included = set.kickoff ? 'YES' : 'NO';
    }
    return model;
  }

  function resolveNext(target) {
    if (target === 'Q4_BY_PRODUCT') return data.produkte[derive().product_id].q4;
    return target;
  }

  /* Hilfen ------------------------------------------------------------------ */
  function esc(text) {
    return String(text == null ? '' : text).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function anchor(cls, text, url, ziel, extra) {
    return '<a class="' + cls + '" href="' + esc(data.linkBasis + url) + '" data-finder-click="' + esc(ziel) + '">' + esc(text) + (extra || '') + '</a>';
  }
  var ARROW = ' <svg width="18" height="18" aria-hidden="true"><use href="#i-arrow"/></svg>';

  /* Zustandsübergänge -------------------------------------------------------- */
  function choose(qid, answer) {
    // DEC11: Ändert sich eine frühere Antwort, werden alle späteren Antworten verworfen.
    if (state.answers[qid] !== answer.id) {
      Object.keys(state.answers).forEach(function (key) {
        if (state.history.indexOf(key) === -1) delete state.answers[key];
      });
    }
    state.answers[qid] = answer.id;
    state.history.push(qid);
    state.vorauswahl = false;
    track('finder_answer', { frage: qid, antwort: answer.id, wert: answer.wert });

    var next = resolveNext(answer.weiter);
    if (next === 'RESULT_PRODUCT' || next === 'RESULT_CONSULT') {
      state.current = null;
      state.route = next === 'RESULT_PRODUCT' ? 'PRODUCT' : 'CONSULT';
    } else {
      state.current = next;
      state.route = null;
    }
    swap(render);
  }

  function back() {
    if (!state.history.length) return;
    state.current = state.history.pop();
    state.route = null;
    state.vorauswahl = false;
    swap(render);
  }

  function restart(vorauswahl) {
    state = freshState();
    state.current = data.start;
    var aid = vorauswahl && data.vorauswahl[vorauswahl];
    var answer = aid && findAnswer(data.start, aid);
    if (!answer) return;
    state.answers[data.start] = answer.id;
    state.history.push(data.start);
    state.current = resolveNext(answer.weiter);
    state.vorauswahl = true;
    track('finder_answer', { frage: data.start, antwort: answer.id, wert: answer.wert, vorauswahl: true });
  }

  /* Darstellung -------------------------------------------------------------- */
  function swap(fn) {
    stage.classList.add('is-switching');
    setTimeout(function () {
      fn();
      stage.scrollTop = 0;
      stage.classList.remove('is-switching');
    }, 200);
  }

  function render() {
    if (state.route) renderResult(); else renderQuestion();
    backBtn.disabled = state.history.length === 0;
    var heading = stage.querySelector('[data-finder-heading]');
    if (heading) heading.focus({ preventScroll: true });
  }

  function renderQuestion() {
    var qid = state.current;
    var q = data.fragen[qid];

    // 5 Kernfragen; liegt eine Zusatzfrage auf dem Pfad, sind es 6.
    var path = state.history.concat(qid);
    var hasExtra = path.some(function (id) { return data.fragen[id].zusatzfrage; });
    var total = data.kernfragen + (hasExtra ? 1 : 0);
    var step = path.length;

    overlay.classList.remove('is-result');
    progress.hidden = false;
    countEl.textContent = data.texte.ui_fortschritt.replace('{x}', step).replace('{n}', total);
    barEl.style.width = (step / total * 100) + '%';

    var html = '<h2 class="os-fq__title" tabindex="-1" data-finder-heading>' + esc(q.frage) + '</h2>';
    if (q.hinweis) html += '<p class="os-fq__help">' + esc(q.hinweis) + '</p>';
    if (state.vorauswahl) html += '<p class="os-fq__hint">' + esc(data.texte.ui_vorauswahl) + '</p>';
    html += '<div class="os-fq__options" role="group" aria-label="' + esc(q.frage) + '">';
    answersOf(qid).forEach(function (a) {
      var pressed = state.answers[qid] === a.id;
      html += '<button type="button" class="os-fq__option" data-answer="' + esc(a.id) + '" aria-pressed="' + pressed + '">' + esc(a.text) + '</button>';
    });
    html += '</div>';
    stage.innerHTML = html;
  }

  function renderResult() {
    overlay.classList.add('is-result');
    progress.hidden = true;
    var html = state.route === 'PRODUCT' ? productResultHtml() : consultResultHtml();
    html += '<p class="os-fr__restart"><button type="button" class="os-link os-link--quiet" data-finder-restart>' + esc(data.texte.ui_neustart) + '</button></p>';
    stage.innerHTML = html;

    stage.querySelectorAll('img.os-fr__img').forEach(function (img) {
      img.addEventListener('error', function () {
        var ph = doc.createElement('div');
        ph.className = 'os-ph os-fr__img';
        ph.innerHTML = '<span class="os-ph__id">Produktbild</span>';
        img.replaceWith(ph);
      });
    });
  }

  /* Reihenfolge laut Tab „Ergebnisaufbau“:
     Titel → Zusammenfassung → Trainingslink → Set-Überschrift → Set-Text → Produktlink
     → Persönliche Begleitung (optional) → Beratungs-Footer */
  function productResultHtml() {
    var t = data.texte;
    var b = data.bausteine;
    var m = derive();
    var p = data.produkte[m.product_id];
    var set = data.setlogik[m.product_id][m.equipment_id];
    var support = b.begleitung[m.support_id][m.kickoff_included];

    var summary1 = b.erfahrung[m.experience_id] + ' ' + b.ziel[m.goal_context_id] + '.';
    var summary2 = b.zeit[m.product_id][m.time_id].replace('{dein_einstieg}', b.einstiegswort[m.experience_id]);

    track('finder_result', { route: 'PRODUCT', produkt: m.product_id, set: set.id, kickoff: m.kickoff_included });

    var html = '<h2 class="os-fr__title" tabindex="-1" data-finder-heading><span class="os-fr__kicker">' + esc(t.RESULT_TITLE_PREFIX) + '</span> ' + esc(p.name) + '</h2>' +
      '<div class="os-fr__grid">' +
        '<div class="os-fr__main">' +
          '<div class="os-fr__summary"><p>' + esc(summary1) + '</p><p>' + esc(summary2) + '</p></div>' +
          '<div class="os-fr__training">' + anchor('os-btn os-btn--secondary', p.trainingCta, p.trainingUrl, 'training') + '</div>' +
        '</div>' +
        '<div class="os-card os-fr__product">' +
          // Bild der EMPFOHLENEN Variante (z. B. Core Complete), nicht pauschal das Entry-Bild
          '<img class="os-fr__img" src="' + esc(set.bildPreview || p.bildPreview) + '" alt="' + esc(p.name + ' – ' + set.set) + '" loading="lazy" width="720" height="540">' +
          '<div class="os-fr__tip"><strong>' + esc(set.ueberschrift) + '</strong>' + esc(set.text) + '</div>' +
          '<div class="os-fr__buttons">' + anchor('os-btn os-btn--primary', p.produktCta, p.produktUrl, 'produkt') + '</div>' +
        '</div>' +
      '</div>';

    if (support) {
      html += '<div class="os-fr__box"><h3>' + esc(t.COACHING_HEADING) + '</h3><p>' + esc(support.text.replace('{set}', set.set)) + '</p>' +
        anchor('os-link', support.cta, support.url, 'begleitung', ARROW) + '</div>';
    }

    html += '<p class="os-fr__consult">' + esc(t.CONSULT_FOOTER) + ' ' + anchor('os-link', t.CONSULT_FOOTER_CTA, t.CONSULT_URL, 'beratung', ARROW) + '</p>';
    return html;
  }

  function consultResultHtml() {
    var t = data.texte;
    track('finder_result', { route: 'CONSULT', produkt: 'CONSULT', set: null });
    return '<h2 class="os-fr__title" tabindex="-1" data-finder-heading>' + esc(t.CONSULT_TITLE) + '</h2>' +
      '<p class="os-fr__text">' + esc(t.CONSULT_BODY) + '</p>' +
      '<div class="os-fr__actions">' + anchor('os-btn os-btn--primary', t.CONSULT_CTA, t.CONSULT_URL, 'beratung') + '</div>';
  }

  /* Öffnen / Schließen ------------------------------------------------------- */
  function open(vorauswahl, trigger) {
    opener = trigger || doc.activeElement;
    overlay.hidden = false;
    doc.body.classList.add('is-locked');
    void overlay.offsetWidth;
    overlay.classList.add('is-open');
    dialog.focus({ preventScroll: true });

    load().then(function () {
      var inProgress = state.current || state.route;
      if (vorauswahl || !inProgress) {
        restart(vorauswahl);
        track('finder_start', { vorauswahl: vorauswahl || null });
      }
      render();
    }).catch(function () {
      progress.hidden = true;
      backBtn.disabled = true;
      stage.innerHTML = '<p class="os-fq__help">Die Finder-Daten konnten nicht geladen werden. Öffne die Vorschau bitte über VS Code Live Preview oder „vorschau-starten.cmd“ (nicht per Doppelklick auf die HTML-Datei).</p>';
    });
  }

  function close() {
    overlay.classList.remove('is-open');
    doc.body.classList.remove('is-locked');
    setTimeout(function () { overlay.hidden = true; }, 300);
    if (opener && opener.focus) opener.focus({ preventScroll: true });
  }

  /* Ereignisse ---------------------------------------------------------------- */
  doc.addEventListener('click', function (e) {
    var openEl = e.target.closest('[data-finder-open]');
    if (openEl) {
      e.preventDefault();
      open(openEl.getAttribute('data-finder-open') || null, openEl);
      return;
    }
    if (e.target.closest('[data-finder-close]')) { close(); return; }
    if (overlay.hidden) return;

    var optionEl = e.target.closest('.os-fq__option');
    if (optionEl) {
      stage.querySelectorAll('.os-fq__option').forEach(function (o) { o.setAttribute('aria-pressed', o === optionEl ? 'true' : 'false'); });
      var qid = state.current;
      var answer = findAnswer(qid, optionEl.getAttribute('data-answer'));
      setTimeout(function () { choose(qid, answer); }, 160);
      return;
    }
    if (e.target.closest('[data-finder-back]')) { back(); return; }
    if (e.target.closest('[data-finder-restart]')) { restart(null); track('finder_start', { vorauswahl: null, neustart: true }); swap(render); return; }

    var clickEl = e.target.closest('[data-finder-click]');
    if (clickEl) track('finder_click', { ziel: clickEl.getAttribute('data-finder-click') });
  });

  doc.addEventListener('keydown', function (e) {
    if (overlay.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    // Fokusfalle
    var focusable = Array.from(dialog.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'))
      .filter(function (el) { return el.offsetParent !== null; });
    if (!focusable.length) { e.preventDefault(); return; }
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && (doc.activeElement === first || !dialog.contains(doc.activeElement) || doc.activeElement === dialog)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* URL-Parameter ?finder=core|fitness|balance|pushup (für Anzeigen) ----------- */
  var param = new URLSearchParams(window.location.search).get('finder');
  if (param !== null) {
    open(param || null, null);
  } else if ('requestIdleCallback' in window) {
    requestIdleCallback(function () { load().catch(function () {}); });
  }

  // Für Tests im Preview (Konsole): osFinder.state() / osFinder.model()
  window.osFinder = {
    open: open,
    close: close,
    state: function () { return JSON.parse(JSON.stringify(state)); },
    model: function () { return data ? derive() : null; }
  };
})();
